import {reception_document} from './state';

/**
 * Establecer un valor para la variable reception_documents.
 */
export function setReceptionDocuments(state, reception_documents) {

    reception_documents.map(rd => {
        rd.check = false;
        rd.total_value_brut = +rd.total_value_brut;
    });

    state.reception_documents = reception_documents;
}

/**
 * Establecer un valor para la variable reception_document.
 */
export function setReceptionDocument(state, reception_document) {
    state.show_left_panel = 1;
    state.accounting_document.document_date = reception_document.issue_date;
    state.accounting_document.due_date = reception_document.issue_date;
    state.reception_document = reception_document;
}

/**
 * Establecer un valor para la variable preloader.
 */
export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para el atributo pdf de la variable reception_document.
 */
export function setPdfToReceptionDocument(state, pdf) {
    if (pdf && pdf.format === '.pdf') {
        pdf.name_file = pdf.url;
    }

    state.reception_document.pdf = pdf;
}

/**
 * Establecer un valor para la variable branch_offices.
 */
export function setBranchOffices(state, branch_offices) {
    branch_offices.map(bo => {
        if (bo.main) {
            state.accounting_document.branch_office_id = bo.id;
        }
    });

    state.branch_offices = branch_offices;
}

/**
 * Establecer un valor para la variable voucher_types.
 */
export function setVoucherTypes(state, voucher_types) {
    voucher_types.map(vo => {
        if (vo.code_voucher_type === state.code_voucher_type) {
            state.params_referrals.voucher_type_id = vo.id;
            state.accounting_document.voucher_type_id = vo.id;
            state.accounting_document.prefix = vo.prefix;
            state.accounting_document.consecutive = vo.consecutive_number + 1;
        }
    });

    state.voucher_types = voucher_types;
}

/**
 * Establecer un valor para la variable concepts.
 */
export function setConcepts(state, concepts) {
    state.concepts = concepts;
}

/**
 * Establecer un valor para el atributo voucher_type_id de la variable accounting_document.
 */
export function setVoucherTypeIdToAccountingDocument(state, voucher_type_id) {
    state.accounting_document.voucher_type_id = voucher_type_id;
}

/**
 * Establecer un valor para la variable concept.
 */
export function setConcept(state, concept) {

    let rules = [
        // SUSCRIPTOR PROVEEDOR RTE-FTE RET-ICA RET-IVA
        ['R-99-PN', 'R-99-PN', true, true, false],
        ['R-99-PN', 'O-13', true, true, false],
        ['R-99-PN', 'O-15', false, false, false],
        ['O-13', 'R-99-PN', true, true, true],
        ['O-13', 'O-13', true, true, false],
        ['O-13', 'O-15', false, false, false],
        ['O-15', 'R-99-PN', true, true, true],
        ['O-15', 'O-13', true, true, false],
        ['O-15', 'O-15', false, false, false]
    ];

    let rule = null;

    if (state.subscriber.fiscal_responsibility // Si el suscriptor tiene responsabilidad fiscal
        && state.reception_document.contact.fiscal_responsibility) {  // Si el tercer tiene responsabilidad fiscal
        rules.map(r => {
            if (r[0] === state.subscriber.fiscal_responsibility.code_parameter
                && r[1] === state.reception_document.contact.fiscal_responsibility.code_parameter) {
                rule = r;
            }
        });
    }

    let tax_ret_ica = null;
    let total_value_brut = +state.reception_document.total_value_brut;

    if (state.contact_warehouse.ret_ica_provider_account && state.contact_warehouse.ret_ica_provider_account.tax) {
        tax_ret_ica = state.contact_warehouse.ret_ica_provider_account.tax;
    }

    state.concepts.data.map(c => {
        if (c.id === concept.id) {
            let debits = 0;
            let credits = 0;

            c.accounting_concept_transactions = concept.accounting_concept_transactions;

            c.accounting_concept_transactions.map(act => {
                let value = 0;
                c.cost_center_1 = null;

                let parameter = act.parameter;

                if (parameter) {
                    if (parameter.code_parameter === '01') { // VALOR BRUTO
                        value = state.reception_document.total_value_brut;
                    } else if (parameter.code_parameter === '02') {// IVA
                        value = state.reception_document.iva;
                    } else if (rule) {

                        let account = act.account;

                        if (account && account.tax) {
                            if (rule[2] && total_value_brut > +account.tax.minimum_base && parameter.code_parameter === '03') { // RETE FUENTE
                                value = Math.round(total_value_brut * account.tax.percentage / 100 * 100) / 100;
                            } else if (rule[4] && total_value_brut > +account.tax.minimum_base && parameter.code_parameter === '04') { // RETE IVA
                                value = Math.round(state.reception_document.ret_iva * account.tax.percentage / 100 * 100) / 100;
                            } else if (rule[3] && tax_ret_ica && account.tax.code === tax_ret_ica.code && total_value_brut > +account.tax.minimum_base && parameter.code_parameter === '05') { // RETE ICA
                                value = Math.round(total_value_brut * account.tax.percentage / 100 * 100) / 100;
                            }
                        }
                    }
                }

                act.value = value;

                if (act.transactions_type === 'D') {
                    debits += +value;
                } else {
                    credits += +value;
                }
            });

            c.accounting_concept_transactions.map(act => {
                if (act.parameter.code_parameter === '06') {
                    act.value = debits - credits;
                }
            });
        }
    });
}

/**
 * Establecer un valor para el atributo observation de la variable accounting_document.
 */
export function setObservationToAccountingDocument(state, observation) {
    state.accounting_document.observation = observation;
}

/**
 * Establecer un valor para la variable subscriber.
 */
export function setSubscriber(state, subscriber) {
    state.subscriber = subscriber;
}

/**
 * Establecer un valor para la variable fiscal_responsibilities.
 */
export function setFiscalResponsibilities(state, fiscal_responsibilities) {
    state.fiscal_responsibilities = fiscal_responsibilities;
}

/**
 * Establecer un valor para la variable accounts.
 */
export function setAccounts(state, accounts) {
    state.accounts = accounts;
}

/**
 * Establecer un valor para el atributo url de la variable modal_pdf.
 */
export function setUrlToModalPdf(state, url) {
    state.modal_pdf.url = url;
    state.modal_pdf.show = !!url;
}

/**
 * Establecer un valor para la variable support_document_mode.
 */
export function setSupportDocumentMode(state, support_document_mode) {
    state.support_document_mode = support_document_mode;
}

/**
 * Establecer un valor para la variable code_voucher_type.
 */
export function setCodeVoucherType(state, code_voucher_type) {
    state.code_voucher_type = code_voucher_type;
}

/**
 * Establecer un valor para la variable contacts.
 */
export function setContacts(state, contacts) {
    state.contacts = contacts;
}

/**
 * Establecer un valor para el atributo contact de la variable reception_document.
 */
export function setContactToReceptionDocument(state, contact) {
    let fiscal_responsibility = state.fiscal_responsibilities.find(fr => fr.id === contact.fiscal_responsibility_id);

    if (!fiscal_responsibility) {
        contact.fiscal_responsibility_id = null;
    }

    state.reception_document.business_name = contact.full_name;
    state.reception_document.identification_number = contact.identification;
    state.reception_document.contact = contact;

    state.mode_referrals = contact.provider && contact.provider.manages_referral ? contact.provider.manages_referral : 0;
}

/**
 * Establecer el valor por defecto de la variable reception_document.
 */
export function resetReceptionDocument(state) {
    state.support_document_mode = false;
    state.mode_referrals = 0;
    state.reception_document = reception_document();
}

/**
 * Establecer un valor para la variable mode_referrals.
 */
export function setModeReferrals(state, mode_referrals) {
    state.mode_referrals = mode_referrals;
}

/**
 * Establecer un valor para la variable code_voucher_type_referrals.
 */
export function setCodeVoucherTypeReferrals(state, code_voucher_type_referrals) {
    state.code_voucher_type_referrals = code_voucher_type_referrals;
}

/**
 * Establecer un valor para la variable show_left_panel.
 */
export function setShowLeftPanel(state, show_left_panel) {

    state.referrals = {data: []};
    state.concepts = {data: []};

    state.show_left_panel = show_left_panel;

    let contact = state.reception_document.contact;

    if (contact && contact.provider) {
        if (show_left_panel === 2) {
            if (contact.provider.causation_voucher_type) {
                state.code_voucher_type = contact.provider.causation_voucher_type.code_voucher_type;
            } else {
                state.code_voucher_type = '320';
            }
        } else if (show_left_panel === 3) {
            if (contact.provider.referral_voucher_type) {
                state.code_voucher_type = contact.provider.referral_voucher_type.code_voucher_type;
            } else {
                state.code_voucher_type = '200';
            }
        }
    } else {
        if (show_left_panel === 2) {
            state.code_voucher_type = '320';
        } else if (show_left_panel === 3) {
            state.code_voucher_type = '200';
        }
    }
}

/**
 * Establecer un valor para la variable referrals.
 */
export function setReferrals(state, referrals) {
    referrals.data.map(r => {
        r.check = false;
    });

    state.referrals = referrals;
}

/**
 * Establecer un valor para el atributo contact_id de la variable params_referrals.
 */
export function setContactIdToParamsReferrals(state, contact_id) {
    state.params_referrals.contact_id = contact_id;
}

/**
 * Establecer un valor para el atributo referrals_ids de la variable accounting_document.
 */
export function setReferralsIdsToAccountingDocument(state, referral_id) {

    if (!state.accounting_document.referrals_ids) {
        state.accounting_document.referrals_ids = [referral_id];
    } else {
        let index = state.accounting_document.referrals_ids.findIndex(r => +r === +referral_id);

        if (index < 0) {
            state.accounting_document.referrals_ids.push(referral_id);
        } else {
            state.accounting_document.referrals_ids.splice(index, 1);
        }
    }
}

/**
 * Establecer un valor para el atributo referrals_ids de la variable reception_document.
 */
export function resetReferralsIdsToAccountingDocument(state) {
    state.accounting_document.referrals_ids = [];
}

/**
 * Establecer un valor para el atributo ids de la variable params_concepts.
 */
export function setIdsToParamsConcepts(state, ids) {
    state.params_concepts.ids = ids;
}

/**
 * Establecer un valor para el atributo affects_prefix_document y affects_number_document de la variable accounting_document.
 */
export function setDataAffectsDocumentToAccountingDocument(state) {
    let prefix = null;
    let consecutive = null;

    if (state.reception_document.document_number !== null) {
        // Expresión regular para buscar letras seguidas de números
        const regex = /([A-Za-z]+)(\d+)/;

        // Ejecutar regex en el código
        const matches = state.reception_document.document_number.match(regex);


        if (matches) {
            prefix = matches[1];
            consecutive = matches[2];
        } else {
            // En caso de no encontrar un prefijo y consecutivo válido
            consecutive = state.reception_document.document_number;
        }
    }

    state.accounting_document.affects_prefix_document = prefix;
    state.accounting_document.affects_number_document = consecutive;
}

/**
 * Establecer un valor para la variable cost_centers.
 */
export function setCostCenters(state, cost_centers) {
    cost_centers.map(cc => {
        cc.code = cc.code_parameter;
        cc.name = cc.name_parameter;
    });

    state.cost_centers = cost_centers;
}

/**
 * Establecer un valor para el atributo show de la variable modal_rejection.
 */
export function setShowToModalRejection(state, show) {
    state.modal_rejection.show = show;
}

/**
 * Establecer un valor para la variable rejection_reasons.
 */
export function setRejectionReasons(state, rejection_reasons) {
    state.rejection_reasons = rejection_reasons;
}

/**
 * Establecer un valor para la variable contact_warehouse.
 */
export function setContactWarehouse(state, contact_warehouse) {
    state.contact_warehouse = contact_warehouse;
}

/**
 * Establecer un valor para el atributo authorized de la variable reception_document.
 */
export function setAuthorizedToReceptionDocument(state, authorized) {
    state.reception_document.authorized = authorized;
}

/**
 * Establecer un valor para el atributo state_id de la variable params.
 */
export function setStateIdToParams(state, state_id) {
    state.params.state_id = state_id;
}

/**
 * Establecer un valor para el atributo show de la variable modal_authorization.
 */
export function setShowToModalAuthorization(state, show) {
    state.modal_authorization.show = show;
    state.modal_authorization.observation = '';
}

/**
 * Establecer un valor para el atributo show de la variable modal_attachments.
 */
export function setShowToModalAttachments(state, show) {
    state.modal_attachments.show = show;
    state.modal_attachments.attachments = null;
}

/**
 * Establecer un valor para la variable attachments.
 */
export function setAttachments(state, attachments) {
    state.attachments = attachments;
}

/**
 * Establecer un valor para el atributo attachment de la variable modal_attachments.
 */
export function setAttachmentToModalAttachments(state, attachment) {
    state.modal_attachments.attachment = attachment;
}

/**
 * Establecer un valor para la variable contacts_lite.
 */
export function setContactsLite(state, contacts_lite) {
    contacts_lite.map(c => {
        c.code = c.identification
        c.name = c.full_name
    })

    state.contacts_lite = contacts_lite;
}



// WEBPACK FOOTER //
// ./src/modules/reception_documents/mutations.js